import React, { useState, useEffect, useRef } from 'react';
import { Get_type_code_options } from '../Comun';
import '../FilterModal.css';

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onApplyFilters: (filters: {
        is_root_response: boolean;
        response: string | null;
        code: string | null;
        type: number | null;
        id_tag: number | null;
        id_provider: number | null;
    }) => void;
    onClearFilters: () => void;
    tags: { id: number; tag: string }[];
    providers: { id: number; name: string }[];
    currentFilters: {
        is_root_response: boolean;
        response: string | null;
        code: string | null;
        type: number | null;
        id_tag: number | null;
        id_provider: number | null;
    };
}

const FilterCodigoModal: React.FC<FilterModalProps> = ({
    isOpen,
    onClose,
    onApplyFilters,
    onClearFilters,
    tags,
    providers,
    currentFilters }) =>
{
    const [isRootResponse, setIsRootResponse] = useState<boolean>(currentFilters.is_root_response);
    const [response, setResponse] = useState<string | null>(currentFilters.response);
    const [code, setCode] = useState<string | null>(currentFilters.code);
    const [type, setType] = useState<number | null>(currentFilters.type);
    const [idTag, setIdTag] = useState<number | null>(currentFilters.id_tag);
    const [idProvider, setIdProvider] = useState<number | null>(currentFilters.id_provider);
    const modalRef = useRef<HTMLDivElement>(null);

    const typeOptions = Get_type_code_options();

    useEffect(() =>
    {
        if (isOpen)
        {
            setIsRootResponse(currentFilters.is_root_response);
            setResponse(currentFilters.response);
            setCode(currentFilters.code);
            setType(currentFilters.type);
            setIdTag(currentFilters.id_tag);
            setIdProvider(currentFilters.id_provider);
        }
    }, [isOpen, currentFilters]);

    useEffect(() =>
    {
        const handleClickOutside = (event: MouseEvent) =>
        {
            if (modalRef.current && !modalRef.current.contains(event.target as Node))
                onClose();
        };

        const handleEscPress = (event: KeyboardEvent) =>
        {
            if (event.key === 'Escape')
                onClose();
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscPress);

        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscPress);
        };
    }, [onClose]);

    const handleApplyFilters = () =>
    {
        onApplyFilters({
            is_root_response: isRootResponse,
            response,
            code,
            type,
            id_tag: idTag,
            id_provider: idProvider,
        });
        onClose();
    };

    const handleClearFilters = () =>
    {
        setIsRootResponse(true);
        setResponse(null);
        setCode(null);
        setType(null);
        setIdTag(null);
        setIdProvider(null);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" ref={modalRef}>
                <h2>Filtrar códigos</h2>
                <form>

                    {/* Código */}
                    <div className="form-group">
                        <input
                            type="text"
                            value={code || ''}
                            placeholder="Todos los códigos"
                            onChange={(e) => setCode(e.target.value || null)}
                        />
                    </div>

                    {/* Tipo de búsqueda + respuesta */}
                    <div className="form-group form-group--row">
                        <select
                            className="select-inline"
                            value={isRootResponse ? 'startsWith' : 'contains'}
                            onChange={(e) => setIsRootResponse(e.target.value === 'startsWith')}
                        >
                            <option value="startsWith">Empieza con</option>
                            <option value="contains">Contiene</option>
                        </select>
                        <input
                            type="text"
                            className="input-response"
                            value={response || ''}
                            placeholder="Todas las respuestas"
                            onChange={(e) => setResponse(e.target.value || null)}
                        />
                    </div>

                    {/* Tipo */}
                    <div className="form-group">
                        <select
                            value={type !== null ? type : ''}
                            onChange={(e) => setType(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">Todos los tipos</option>
                            {typeOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Etiqueta */}
                    <div className="form-group">
                        <select
                            value={idTag !== null ? idTag : ''}
                            onChange={(e) => setIdTag(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">Todas las etiquetas</option>
                            {tags.map(tag => (
                                <option key={tag.id} value={tag.id}>
                                    {tag.tag}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Proveedor */}
                    <div className="form-group">
                        <select
                            value={idProvider !== null ? idProvider : ''}
                            onChange={(e) => setIdProvider(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">Todos los proveedores</option>
                            {providers.map(provider => (
                                <option key={provider.id} value={provider.id}>
                                    {provider.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Acciones */}
                    <div className="modal-actions">
                        <button type="button" className="delete-filter-button" onClick={handleClearFilters}>
                            Borrar filtros
                        </button>
                        <div className="modal-actions-right">
                            <button type="button" className="filter-button" onClick={onClose}>Cancelar</button>
                            <button type="button" className="filter-button2" onClick={handleApplyFilters}>Aplicar</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default FilterCodigoModal;